import { jsPDF } from 'jspdf'

async function toDataUrl(url) {
  const res = await fetch(url)
  const blob = await res.blob()
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}

function fmt(n) {
  return Number(n || 0).toFixed(2)
}

function toASCII(text) {
  return String(text || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\x20-\x7E]/g, '')
}

function wrap(text, max) {
  const s = String(text || '')
  if (s.length <= max) return [s]
  const lines = []
  let i = 0
  while (i < s.length) {
    lines.push(s.slice(i, i + max))
    i += max
  }
  return lines
}

export async function generateReceiptPDF({ logoUrl = '/img/sushi.png', title = 'Sushito', saleId, items = [], total = 0, paymentMethod = 'cash', amountReceived = null, change = null, customerName = null, status = 'success' }) {
  const doc = new jsPDF('p', 'mm', [58, 200])
  doc.setFont('helvetica', 'normal')
  const marginL = 4
  const marginR = 54
  const contentWidth = marginR - marginL

  function wrapByWidth(text, maxWidth, size) {
    doc.setFontSize(size)
    const words = toASCII(text).split(/\s+/).filter(Boolean)
    const lines = []
    let line = ''
    for (const w of words) {
      const test = line ? `${line} ${w}` : w
      const width = doc.getTextWidth(test)
      if (width <= maxWidth) {
        line = test
      } else {
        if (line) lines.push(line)
        line = w
      }
    }
    if (line) lines.push(line)
    return lines.length ? lines : ['']
  }

  const rowsH = items.reduce((h, it) => h + (wrapByWidth(it.name, contentWidth, 9).length * 5) + 6, 0)
  const baseH = 60 + rowsH + 34 + (customerName ? 5 : 0)
  const height = Math.max(120, baseH)
  doc.internal.pageSize.height = height
  let y = 6
  if (logoUrl) {
    try {
      const img = await toDataUrl(logoUrl)
      doc.addImage(img, 'PNG', 10, y, 38, 12)
      y += 14
    } catch { }
  }
  doc.setFontSize(11)
  doc.text(String(title), 29, y, { align: 'center' })
  y += 5
  doc.setFontSize(9)
  doc.text(`Folio: ${saleId ?? ''}`, 29, y, { align: 'center' })
  y += 4
  doc.text(new Date().toLocaleString(), 29, y, { align: 'center' })
  y += 5
  if (customerName) {
    doc.setFontSize(9)
    doc.text(`Cliente: ${toASCII(customerName)}`, 29, y, { align: 'center' })
    y += 5
  }
  doc.line(marginL, y, marginR, y)
  y += 4
  doc.setFontSize(9)
  items.forEach((it, idx) => {
    const nameLines = wrapByWidth(it.name, contentWidth, 9)
    for (const ln of nameLines) {
      doc.text(toASCII(ln), marginL, y)
      y += 5
    }
    const qty = Number(it.qty || 0)
    const price = Number(it.unit_price || 0)
    const lineTotal = Number((qty * price).toFixed(2))
    doc.text(toASCII(`${qty} x $${fmt(price)}`), marginL, y)
    doc.text(toASCII(`$${fmt(lineTotal)}`), marginR, y, { align: 'right' })
    y += 6
    if (idx < items.length - 1) {
      const makeDash = () => {
        let s = '-'
        while (doc.getTextWidth(s) < contentWidth) s += '-'
        return s
      }
      const dash = makeDash()
      doc.text(dash, marginL, y)
      y += 4
    }
  })
  doc.line(marginL, y, marginR, y)
  y += 5
  doc.setFontSize(10)
  doc.text(`TOTAL: $${fmt(total)}`, marginR, y, { align: 'right' })
  y += 5
  doc.setFontSize(9)
  doc.text(`Pago: ${paymentMethod === 'card' ? 'Tarjeta' : 'Efectivo'}`, marginL, y)
  y += 5
  const statusText = status === 'canceled' ? 'Cancelado' : (status === 'refunded' ? 'Reembolsado' : 'Compra exitosa')
  if (status === 'canceled') doc.setTextColor(239, 68, 68)
  else if (status === 'refunded') doc.setTextColor(20, 184, 166)
  else doc.setTextColor(34, 197, 94)
  doc.text(`Estado: ${statusText}`, marginL, y)
  doc.setTextColor(0, 0, 0)
  y += 5
  if (amountReceived != null) {
    doc.text(`Recibido: $${fmt(amountReceived)}`, marginL, y)
    y += 5
    doc.text(`Cambio: $${fmt(change)}`, marginL, y)
    y += 5
  }
  doc.line(marginL, y, marginR, y)
  y += 6
  doc.setFontSize(8)
  doc.text('Gracias por su compra', 29, y, { align: 'center' })
  doc.save(`ticket-${saleId ?? Date.now()}.pdf`)
}
